










































































import Vue, { PropOptions } from 'vue';
import { IFrame as ifr, CFrame, IFrameEdit } from './GadgetFrame.vue';
export type IFrame = ifr;
export { CFrame };
// export interface IFrame {
//   error: boolean;
//   show: boolean;
//   disabled: boolean;
//   detail: boolean;
//   cover: boolean;
//   edit: boolean;
//   options: boolean;
// }

// export  class CFrame implements IFrame {
//   public error = false;
//   public show = true;
//   public disabled = false;
//   public detail = false;
//   public cover = false;
//   public edit = false;
//   public options = false;
// }

// export interface IFrameEdit {
//   title: string;
//   comment: string;
// }
export default Vue.extend({
  name: 'GadgetFrame',
  props: {
    title: String,
    csvtitle: String,
    comment: String,
    frameData: Object as PropOptions<ifr>,
    options: Object,
    optionItems: Array,
  },
  data() {
    return {
      titleEdit: '',
      type: '',
      materials: {},
      memoBack: false,
      commentEditFlag: false,
      commentEdit: '',
      optionsModal: false,
      csvframe: false,
    };
  },
  computed: {
    EDIT() {
      // return this.edit ? '' : 'no_edit';
      return false;
    },
  },
  mounted() {
    this.$data.titleEdit = this.$props.title;
    this.$data.commentEdit = this.$props.comment.replace(/<br>/gi, '\n');
  },
  methods: {
    returnSetting(key: string): any {
      return (this as any).frameData[key] ? (this as any).frameData[key] : false;
    },
    onClickDetail() {
      if (!this.frameData.cover) {
        this.$emit('detail');
      }
    },
    onClickTrash() {
      if (!this.frameData.cover) {
        this.$emit('trash');
      }
    },
    onClickAddEvent() {
      this.$emit('add');
    },
    onClickQuestionEdit() {
      this.commentEditFlag = !this.commentEditFlag;
    },
    onMemoback(flag: boolean) {
      const result = flag;
      /*
      if (this.edit) {
        result = false;
      }
      */
      this.memoBack = result;
    },
    onClickOptions() {
      this.optionsModal = !this.optionsModal;
    },
  },
  watch: {
    type() {
      // console.log('type chnage');
    },
    titleEdit() {
      this.$emit('frameDataEdit', {title: this.titleEdit, comment: this.commentEdit} as IFrameEdit);
    },
    commentEdit() {
      this.$emit('frameDataEdit', {title: this.titleEdit, comment: this.commentEdit} as IFrameEdit);
    },
    options() {
      this.optionsModal = false;
    },
    // item() {
    //   this.type = this.item.gadgetData.type;
    //   this.materials = this.item.gadgetData.materials;
    // },
  },
});

